import TableCell from "@tiptap/extension-table-cell";
import TableHeader from "@tiptap/extension-table-header";

const addVerticalAlignAttribute = (parentAttributes: any) => {
  return {
    ...parentAttributes,
    verticalAlign: {
      default: "middle",
      parseHTML: (element) => {
        return (
          element.getAttribute("data-vertical-align") || element.style.verticalAlign || "middle"
        );
      },
      renderHTML: (attributes) => {
        const align = attributes.verticalAlign || "middle";
        return {
          "data-vertical-align": align,
          style: `vertical-align: ${align}`,
        };
      },
    },
  };
};

export const CustomTableCell = TableCell.extend({
  addAttributes() {
    return addVerticalAlignAttribute(this.parent?.());
  },
});

export const CustomTableHeader = TableHeader.extend({
  addAttributes() {
    return addVerticalAlignAttribute(this.parent?.());
  },
});
